export default __webpack_public_path__ + "static/media/diamond.479535f5.gif";